import styled from "styled-components";
import { Icon } from "@iconify/react";
import { MOBILE_WIDTH } from "../../constants";

export const SocialIcon = styled(Icon)`
  color: ${(props) => props.$color || "#ffffff"};
  font-size: ${(props) => props.$size || "24px"};
  @media ${MOBILE_WIDTH} {
    font-size: ${(props) => props.$size || "24px"};
  }
  &: last-child {
    padding-left: ${(props) => (props.$noPadding ? "0px" : "12px")};
  }
  :hover {
    opacity: 0.6;
  }
`;
